export default {
  returnProduct: 'Returnere produkt',
  returnOrder: 'Returnere ordre',
  introduction:
    'Dersom du har behov for å returnere eller reklamere på et produkt, anbefaler vi at du besøker en av våre butikker. Om du ikke har mulighet til å besøke en av våre butikker, kan du fylle inn ditt ordrenummer og postnummer for å sende inn din retur. Les gjerne mer om våre generøse vilkår for garanti og åpent kjøp nedenfor.',
  searchStoreDescription:
    'Du vet at du også kan reklamere på eller returnere varer via våre butikker? Søk nedenfor for å finne din nærmeste butikk.',
  searchStoreTitle: 'Returner i butikk',
  searchStoreLabel: 'Butikknavn eller sted',
  searchStoreButton: 'Finn din butikk',
  searchOrderTitle: 'Send inn din retur',
  searchOrderDescription:
    'Vi har en enkel prosess for å gjennomføre returer på nett. Fyll inn ordrenummer og postnummer for å komme videre.',
  orderNumber: 'Ordrenummer',
  postCode: 'Postnummer',
  findOrder: 'Finn ordre',
  errorNumbersOnly: 'Postnummeret kan kun bestå av sifre.',
  errorPostCodeFiveChars: 'Postnummeret må bestå av 4 tegn',
  orderError: 'Kunne ikke finne din ordre',
  orderErrorPart1: 'Vi fant ikke ordre din. Kontakt vår ',
  orderErrorPart2: 'https://www.clasohlson.com/no/contact-us',
  orderErrorPart3: 'kundeservice',
  orderErrorPart4: ' for å fortsette med retur.',
  loginBtnText: 'Eller logg inn og velg ordre',
  termsTitle: 'Dette er våre kjøpvilkår',
  termsDescription:
    'Vi har lang erfaring med å ville tilby god service til våre kunder, og derfor har vi også fokusert på å tilby kjøpsvilkår som kommer deg som kunde til gode. Kikk på en av kategoriene nedenfor for å lese mer.',
  generalError: 'Noe gikk galt.',
  deleteRowConfirm: 'Er du sikker på at du vil  ta bort denne artikkelen fra din retur?',
  stepOneTitle: 'Velg de produktene du vil returnere ved å klikke på dem',
  stepTwoTitle: 'Velg returårsak for produktene du har valgt',
  stepThreeTitle: 'Du er nå klar for å sende inn din returforespørsel!',
  goBack: 'Gå tilbake',
  send: 'Send inn returforespørsel',
  returnSentTitle: 'Din forespørsel er sendt inn!',
  returnSentDescription:
    'Vårt kundesenter tar kontakt med deg så snart som mulig, normalt innen to virkedager for å hjelpe deg videre med din retur.',
  returnSentCloseBtn: 'Lukk vinduet og gå til forsiden',
  returnNotSentTitle: 'Noe gikk galt.',
  returnNotSentDescription:
    'Forsøk å sende inn på nytt. Kontakt vårt kundesenter dersom problemet vedvarer.',
  returnNotSentCloseBtn: 'Lukk',
  productsInOrder: 'Produkter fra denne ordren',
  productsSelected: 'Valgt(e) produkt(er)',
  continue: 'Fortsett',
  contactTitle: 'Har du spørsmål gjeldende din retur?',
  contactDescription: 'Kontakt vårt kundesenter, så hjelper vi deg',
  contactBtn: 'Kontakt oss',
  orderHeaderDescription:
    'Vi har funnet ordren din og du finner det du bestilte nedenfor. Fyll inn de produktene og antallene du vil returnere, så tar vårt kundesenter kontakt med deg.',
  orderHeaderDescriptionContinue: 'for å finne din nærmeste butikk.',
  clickHere: 'Klikk her',
  orderNo: 'Ordrenr.',
  date: 'Dato',
  products: 'Produkter',
  amount: 'Sum',
  status: 'Status',
  artNr: 'Art. nr',
  incVat: 'Inkl. moms',
  product: 'Produkt',
  numberOfItems: 'Antall',
  reasonForReturn: 'Returårsak',
  selectReason: 'Velg en returårsak',
  Reklamation: 'Reklamasjon',
  'Öppet köp': 'Åpent kjøp',
  selectAction: 'Hva er grunnen til at du vil reklamere på varen? ',
  selectActionOpenPurchase: 'Hva er grunnen til at du vil returnere på varen? ',
  mustSelectOneReason: 'Du må velge minst ett av alternativene nedenfor',
  'Trasig vara': 'Defekt produkt',
  Transportvara: 'Transportskade',
  'Fellevererad vara': 'Mottok feil vare',
  Annat: 'Annet',
  'Fel produkt': 'Mottok feil produkt',
  'Fel storlek': 'Feil størrelse',
  'Fel färg': 'Feil farge',
  additionalInformation: 'Ytterligere informasjon',
  processOneTitle: 'Åpent kjøp',
  processOneDescription: 'Benytt åpent kjøp i inntil 365 dager',
  processTwoTitle: 'Returner',
  processTwoDescription: 'Regler for retur av varer',
  processThreeTitle: 'Tilbakebetalinger',
  processThreeDescription: 'Tilbakebetaling uten unødvendig forsinkelse',
  processFourTitle: 'Garanti',
  processFourDescription: 'Minst 2 års garanti på alle våre produkter',
  mustEnterNotes:
    'Fyll ut ytterligere informasjon om hvorfor du ønsker å reklamere på produktet ditt i feltet nedenfor.',
  returnProductError: 'Dette produktet kan ikke returneres',
  fetchingOrderLabel: 'Henter ordre...',
  email: 'Epostadresse',
  name: 'Navn',
  privacyStatementText: 'Les mer om hvordan vi behandler dine personopplysninger.',
  privacyStatementLinkLabel: 'Vår personvernerklæring',
  privacyStatementLink: 'https://www.clasohlson.com/no/privacy-statement-contact',
  dateFormat: 'dd.MM.yyyy',
  noReturnQtyMessage: 'Vær vennlig og fyll inn antall produkter du vil returnere for å gå videre',
};
